import { z } from 'zod';

export const AppointmentStatusSchema = z.enum([
  'pending',
  'expired',
  'accepted',
  'inCall',
  'declined',
  'cancelled',
  'finished',
  'free_of_charge',
  'owed',
  'unpaid',
  'reporting',
]);
export type AppointmentStatus = z.infer<typeof AppointmentStatusSchema>;

export const AppointmentStatusEnum = AppointmentStatusSchema.enum;
